import { PermitSitePhotosTabActionTypes, ADD_SITE_PHOTO, DELETE_SITE_PHOTO } from "./types";
import { RawFile } from "../../models/RawFile";

export function addSitePhoto(
    sitePhotoFileKey: string,
    photoFile: RawFile,
    createdById: string,
    comments: string
): PermitSitePhotosTabActionTypes {
    return {
        type: ADD_SITE_PHOTO,
        sitePhotoFileKey,
        photoFile,
        createdById,
        comments,
    };
}

export function deleteSitePhoto(sitePhotoId: string): PermitSitePhotosTabActionTypes {
    return {
        type: DELETE_SITE_PHOTO,
        sitePhotoId,
    };
}
